import { useApp } from '../store/AppContext';
import { PlaceholderPage } from './PlaceholderPage';
import { PositionsPage } from './PositionsPage';
import { TasksPage } from './TasksPage';

export function SearchPage() {
  const { ui } = useApp();
  if (ui.scope !== 'bing') {
    return <PlaceholderPage title="Поисковик" />;
  }
  return ui.subpage === 'positions' ? <PositionsPage /> : <TasksPage />;
}
